module.exports = __webpack_public_path__ + "img/003-accountant.44b196f2.png";